import angular from 'angular';

import defaultTemplate from './default-template.html';
import template from './daterange.html';
import { TZ_FILTER } from './../date/timezone-filter-constants';

const DAY = 'day';
const customFilter = {
  id: 'customFilterId',
  label: 'components.daterange.custom-filter'
};
const isDefined = angular.isDefined;

class DaterangeController {
  static get $inject() {
    return [
      '$scope', '$translate', '$filter', '$element', '$attrs', '$document', '$timeout',
      'moment', 'timezonesService', 'FROM_EVENT_NAMESPACE', 'TO_EVENT_NAMESPACE'
    ];
  }

  constructor(
    $scope, $translate, $filter, $element, $attrs, $document, $timeout,
    moment, timezonesService, FROM_EVENT_NAMESPACE, TO_EVENT_NAMESPACE
  ) {
    this.$scope = $scope;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$element = $element;
    this.$attrs = $attrs;
    this.$document = $document;
    this.$timeout = $timeout;
    this.moment = moment;
    this.timezonesService = timezonesService;

    this.TZ_FILTER = TZ_FILTER;
    this.FROM_EVENT_NAMESPACE = FROM_EVENT_NAMESPACE;
    this.TO_EVENT_NAMESPACE = TO_EVENT_NAMESPACE;

    this.$scope.$watch(
      () => this.timezonesService.data,
      () => {
        this.initDateRangeTimezone(this.ngModel.$modelValue);
      }
    );
  }

  get minFromDate() {
    return this.getFromDateOption('min');
  }

  get maxFromDate() {
    return this.getFromDateOption('max');
  }

  get minToDate() {
    return this.getToDateOption('min');
  }

  get maxToDate() {
    return this.getToDateOption('max');
  }

  get fromDateDisabled() {
    return this.getFromDateOption('dateDisabled');
  }

  get toDateDisabled() {
    return this.getToDateOption('dateDisabled');
  }

  getFromDateOption(key) {
    return this.fromOptions && this.fromOptions[key] || this[key];
  }

  getToDateOption(key) {
    return this.toOptions && this.toOptions[key] || this[key];
  }

  $onInit() {
    this.ngModel.$formatters.push(this.formatModel.bind(this));
    this.ngModel.$render = this.renderView.bind(this);
    this.ngModel.$parsers.push(this.parseView.bind(this));

    this.displayRight = isDefined(this.$attrs.right);
    this.hasTime = isDefined(this.$attrs.time);
    this.hasTimezone = angular.isDefined(this.$attrs.timezone);
    this.hasTimezoneLabel = angular.isDefined(this.$attrs.timezoneLabel) || this.hasTimezone;
    this.hasFilterTimezone = isDefined(this.$attrs.filterTimezones);
    this.hasApplyButton = isDefined(this.$attrs.applyButton);
    this.timezoneFilter = this.TZ_FILTER.SHOW_ALL;

    this.dateRangeDropdown =
      angular.element(this.$element[0].querySelector('.date-range-container'));

    this.initFormat();
    this.boundCloser = this.closeDropdown.bind(this);

    this.$translate(this.fromPlaceholder || 'components.daterange.placeholder')
      .then(value => this.fromPlaceholder = value)
      .catch(value => this.fromPlaceholder = value);

    this.$translate(this.toPlaceholder || 'components.daterange.placeholder')
      .then(value => this.toPlaceholder = value)
      .catch(value => this.toPlaceholder = value);

    this.$translate(this.applyButtonText || 'components.daterange.apply')
      .then(value => this.applyButtonText = value)
      .catch(value => this.applyButtonText = value);

    this.$translate(this.cancelButtonText || 'components.daterange.cancel')
      .then(value => this.cancelButtonText = value)
      .catch(value => this.cancelButtonText = value);

    this.ngModel.$validators.invalidRange = (modelValue) => {
      return angular.isUndefined(modelValue) || !!modelValue.to && !!modelValue.from;
    };

    this.showFilter = 'rangeFilters' in this.$attrs &&
      Array.isArray(this.rangeFilters) && this.rangeFilters.length > 0;

    if (this.showFilter) {
      // add custom
      //this.rangeFiltersCopy = [...this.rangeFilters, customFilter];

      // if there is selected === true, then do this.setRangeValues(rangeObj)
      const preSelectedRange = this.findPreSelectedRange(this.rangeFilters);

      if (preSelectedRange.length) {
        this.currentFilterId = preSelectedRange[0].id;

        this.filterSelected = true;

        // have to set ng-model values after $digest loop completed
        this.$timeout(() => this.setRangeValues(preSelectedRange[0]));

      } else {
        this.currentFilterId = -1;
        this.filterSelected = false;
      }

      this.customFilterDisabled = 'customRangeNotFilterable' in this.$attrs;
    }

    this.mode = this.mode || DAY;
  }

  setDateRangeViewValue() {
    if (this.dateRangeModel && this.timezone) {
      const viewValue = angular.extend({}, this.dateRangeModel, {timezone: this.timezone.id});
      this.ngModel.$setViewValue(viewValue);
      this.ngModel.$setTouched();
    }
  }

  findPreSelectedRange(filters) {
    return filters
        .map(filter => this.hasSubfilters(filter) ? filter.subfilters : filter)
        .reduce((acc, filter) => acc.concat(filter), [])
        .filter(filter => filter.selected);
  }

  hasSubfilters(filter) {
    return Array.isArray(filter.subfilters) && filter.subfilters.length > 0;
  }

  formatModel(modelValue) {
    if (modelValue && modelValue.timezone) {
      const formattedModelValue = {
        from: this.timezonesService.toTimezone(modelValue.from, modelValue.timezone),
        to: this.timezonesService.toTimezone(modelValue.to, modelValue.timezone),
        timezone: modelValue.timezone
      };
      return formattedModelValue;
    }

    return modelValue;
  }

  initLimits() {
    if (!this.timezone) {
      return undefined;
    }


    this.limits = {
      min: undefined,
      max: undefined,
      from: {
        min: undefined,
        max: undefined
      },
      to: {
        min: undefined,
        max: undefined
      }
    };

    if (this.min) {
      this.limits.min = angular.copy(this.min);
      this.min = this.timezonesService.toTimezone(this.limits.min, this.timezone.id);
    }

    if (this.fromOptions && this.fromOptions.min) {
      this.limits.from.min = angular.copy(this.fromOptions.min);
      this.fromOptions.min =
        this.timezonesService.toTimezone(this.limits.from.min, this.timezone.id);
    }

    if (this.toOptions && this.toOptions.min) {
      this.limits.to.min = angular.copy(this.toOptions.min);
      this.toOptions.min =
        this.timezonesService.toTimezone(this.limits.to.min, this.timezone.id);
    }

    if (this.max) {
      this.limits.max = angular.copy(this.max);
      this.max =
        this.timezonesService.toTimezone(this.limits.max, this.timezone.id);
    }

    if (this.fromOptions && this.fromOptions.max) {
      this.limits.from.max = angular.copy(this.fromOptions.max);
      this.fromOptions.max =
        this.timezonesService.toTimezone(this.limits.from.max, this.timezone.id);
    }

    if (this.toOptions && this.toOptions.max) {
      this.limits.to.max = angular.copy(this.toOptions.max);
      this.toOptions.max =
        this.timezonesService.toTimezone(this.limits.to.max, this.timezone.id);
    }
  }

  renderView() {
    if (!this.ngModel.$viewValue) {
      this.dateRangeModel = undefined;
      return undefined;
    }

    this.dateRangeModel = angular.copy(this.ngModel.$viewValue);

    this.setTime(this.dateRangeModel);
    this.initDateRangeTimezone(this.ngModel.$viewValue);
  }

  parseView(viewValue) {
    viewValue.from = this.timezonesService.fromTimezone(viewValue.from, this.timezone.id);
    viewValue.to = this.timezonesService.fromTimezone(viewValue.to, this.timezone.id);
    if (this.min) {
      this.min = this.timezonesService.fromTimezone(this.limits.min, this.timezone.id);
    }

    if (this.fromOptions && this.fromOptions.min) {
      this.fromOptions.min =
        this.timezonesService.fromTimezone(this.limits.from.min, this.timezone.id);
    }

    if (this.toOptions && this.toOptions.min) {
      this.toOptions.min =
        this.timezonesService.fromTimezone(this.limits.to.min, this.timezone.id);
    }

    if (this.max) {
      this.max = this.timezonesService.fromTimezone(this.limits.max, this.timezone.id);
    }

    if (this.fromOptions && this.fromOptions.max) {
      this.fromOptions.max =
        this.timezonesService.fromTimezone(this.limits.from.max, this.timezone.id);
    }

    if (this.toOptions && this.toOptions.max) {
      this.toOptions.max =
        this.timezonesService.fromTimezone(this.limits.to.max, this.timezone.id);
    }

    return viewValue;
  }

  get fromDate() {
    if (angular.isUndefined(this.dateRangeModel) || angular.isUndefined(this.dateRangeModel.from)) {
      return false;
    } else {
      return this.$filter('date')(this.dateRangeModel.from, this.format);
    }
  }

  get toDate() {
    if (angular.isUndefined(this.dateRangeModel) || angular.isUndefined(this.dateRangeModel.to)) {
      return false;
    } else {
      return this.$filter('date')(this.dateRangeModel.to, this.format);
    }
  }

  initDateRangeTimezone(modelValue) {
    if (modelValue && modelValue.timezone) {
      this.timezone = this.timezonesService.data.find(tz => tz.id === modelValue.timezone);
    } else {
      const guessedTimezone = this.timezonesService.getGuessedTimezone();
      this.timezone = guessedTimezone || this.timezonesService.getGmtTimezone();
    }
    this.initLimits();
  }

  initFormat() {
    if (this.format) {
      return;
    }

    if (angular.isUndefined(this.$attrs.time) && angular.isUndefined(this.$attrs.timezone)) {
      this.format = 'MMM d, y'; // e.g. Sep 3, 2010
    } else if (angular.isDefined(this.$attrs.noMeridian)) {
      this.format = 'MMM d, y HH:mm'; // e.g. Sep 3, 2010 21:23
    } else {
      this.format = 'MMM d, y h:mm a'; // e.g. Sep 3, 2010 1:15 PM
    }
  }

  toggleDropdown() {
    if (this.isDisabled || this.isReadonly) {
      return;
    }

    if (this.dateRangeDropdown.hasClass('ng-hide')) {
      this.hideAllDateRangeDropdowns();
      this.showDropdown();
      this.setLastSavedState();
    } else {
      this.hideDropdown();
      if (!this.hasApplyButton) {
        this.$element.triggerHandler('blur');
      }
    }
  }

  showDropdown() {
    this.dateRangeDropdown.removeClass('ng-hide');
    this.dateRangeDropdown.parent().addClass('open');
    this.$document.on('mousedown', this.boundCloser);
  }

  hideDropdown() {
    this.dateRangeDropdown.addClass('ng-hide');
    this.dateRangeDropdown.parent().removeClass('open');
    this.$document.off('mousedown', this.boundCloser);
  }

  preventDropdownClose($event) {
    $event.stopPropagation();
  }

  closeDropdown($event) {
    let node = angular.element($event.target);

    while (node[0].nodeName !== 'HTML') {
      if (node[0].nodeName === 'AKAM-DATERANGE') {
        return;
      } else {
        node = node.parent();
      }
    }
    if (!this.hasApplyButton) {
      this.$element.triggerHandler('blur');
    }
    this.dateRangeDropdown.addClass('ng-hide');
    this.dateRangeDropdown.parent().removeClass('open');
    this.$document.off('mousedown', this.boundCloser);
  }

  hideAllDateRangeDropdowns() {
    const dropdowns = this.$document[0].querySelectorAll('akam-daterange .date-range-container');

    for (let i = 0; i < dropdowns.length; i++) {
      angular.element(dropdowns[i]).addClass('ng-hide');
      angular.element(dropdowns[i]).parent().removeClass('open');
    }
  }

  hideAllTimeDropdowns() {
    const dropdowns = this.$document[0].querySelectorAll('.akam-time.dropdown.open');
    for (let i = 0; i < dropdowns.length; i++) {
      angular.element(dropdowns[i]).removeClass('open');
    }
  }

  checkAndProcessTime() {
    if (this.hasTime || this.hasTimezone) {
      return;
    }

    // if there is no time attribute, set from to start of its day and to the end of its day
    this.dateRangeModel.from = this.moment(this.dateRangeModel.from).startOf('day').toDate();
    this.dateRangeModel.to = this.moment(this.dateRangeModel.to).endOf('day').toDate();
  }

  updateFromDate() {
    let from, to, invalidRange;

    this.activeFilter = '';

    this.checkAndProcessTime();

    if (this.hasTimezone) {
      from = this.moment(this.dateRangeModel.from).tz(this.timezone.id);
      to = this.moment(this.dateRangeModel.to).tz(this.timezone.id);
    } else {
      from = this.moment(this.dateRangeModel.from);
      to = this.moment(this.dateRangeModel.to);
    }

    invalidRange = this.hasTime || this.hasTimezone ?
      from.isAfter(to, 'minute') :
      from.isAfter(to, 'day');

    if (invalidRange || !this.toDate) {
      this.recalculateToDate(this.dateRangeModel.from);
    }

    if (this.dateRangeModel.from === undefined && this.dateRangeModel.to === undefined) {
      this.hideAllTimeDropdowns();
    }

    this.setFromTime(this.dateRangeModel);
    this.setDateRangeViewValue();

    if (this.hasFilterTimezone) {
      this.reFilterTimezones();
    }
    this.setFromRangeTimes();
  }

  updateToDate() {
    let from, to, invalidRange;

    this.activeFilter = '';

    this.checkAndProcessTime();

    if (this.hasTimezone) {
      from = this.moment(this.dateRangeModel.from).tz(this.timezone.id);
      to = this.moment(this.dateRangeModel.to).tz(this.timezone.id);
    } else {
      from = this.moment(this.dateRangeModel.from);
      to = this.moment(this.dateRangeModel.to);
    }

    invalidRange = this.hasTime || this.hasTimezone ?
      to.isBefore(from, 'minute') :
      to.isBefore(from, 'day');

    if (invalidRange || !this.fromDate) {
      this.recalculateFromDate(this.dateRangeModel.to);
    }

    if (this.dateRangeModel.to === undefined && this.dateRangeModel.from === undefined) {
      this.hideAllTimeDropdowns();
    }

    this.setToTime(this.dateRangeModel);
    this.setDateRangeViewValue();

    if (this.hasFilterTimezone) {
      this.reFilterTimezones();
    }
    this.setToRangeTimes();
  }

  recalculateFromDate(beforeDate) {
    this.$scope.$broadcast(`${this.FROM_EVENT_NAMESPACE}:move-backward`, beforeDate);
  }

  recalculateToDate(afterDate) {
    this.$scope.$broadcast(`${this.TO_EVENT_NAMESPACE}:move-forward`, afterDate);
  }

  setRangeValues(filter) {
    //add active class to that filter
    this.filterSelected = true;
    this.currentFilterId = filter.id;

    const dateRange = this.onFilterChange({
      $event: {
        id: filter.id
      }
    });

    if (dateRange) {
      this.dateRangeModel = Object.assign({ rangeId: this.currentFilterId }, dateRange);

      this.updateFromDate();
      this.updateToDate();

      if (this.hasFilterTimezone) {
        this.reFilterTimezones();
      }
    }
  }

  isActive(filter) {
    if (this.dateRangeModel && this.dateRangeModel.rangeId) {
      return this.dateRangeModel.rangeId === filter.id;
    }

    return false;
  }

  filterItemSelect(e, filter, customize = false) {
    this.setRangeValues(filter);
    if (customize) {
      this.filterSelected = false;
    }
    // prevent anchors from going to href
    e.stopPropagation();
    e.preventDefault();
  }

  customFilterItemSelect(e) {
    this.dateRangeModel.rangeId = customFilter.id;
    this.filterSelected = false;

    // prevent anchors from going to href
    e.stopPropagation();
    e.preventDefault();

    if (this.hasFilterTimezone) {
      this.reFilterTimezones();
    }
  }

  reFilterTimezones() {
    if (this.dateRangeModel.rangeId === customFilter.id) {
      this.timezoneFilter = this.TZ_FILTER.SHOW_ALL;
      return;
    }

    const dayDiff = Math.abs(
      this.moment(this.dateRangeModel.to).diff(
        this.moment(this.dateRangeModel.from), 'days'));

    if (dayDiff <= 1) {
      this.timezoneFilter = this.TZ_FILTER.SHOW_ALL;
    } else if (dayDiff <= 30) {
      this.timezoneFilter = this.TZ_FILTER.SHOW_FULL_HOURS_ONLY;
    } else {
      this.timezoneFilter = this.TZ_FILTER.SHOW_GMT_ONLY;
    }
  }

  setLastSavedState() {
    this.pristineModel = angular.copy(this.ngModel.$viewValue);
  }

  recoverLastSavedState() {
    if (!this.equalsToPristineModel(this.dateRangeModel, this.timezone)) {
      this.dateRangeModel = angular.copy(this.pristineModel);

      if (this.dateRangeModel) {
        this.updateFromDate();
        this.updateToDate();
      }

      if (this.hasTimezone) {
        this.initDateRangeTimezone(this.pristineModel);
      }
    }
  }

  equalsToPristineModel(dateRangeModel, timezone) {
    if (angular.isUndefined(this.pristineModel)) {
      return angular.isUndefined(dateRangeModel);
    }

    const isFromEqual = angular.equals(dateRangeModel.from, this.pristineModel.from);
    const isToEqual = angular.equals(dateRangeModel.to, this.pristineModel.to);
    const isTimezoneUndefined = angular.isUndefined(timezone);
    const isTimezoneEqual = angular.equals(timezone, this.pristineModel.timezone);

    return isFromEqual && isToEqual && (isTimezoneUndefined || isTimezoneEqual);
  }

  applyButtonClicked() {
    this.$element.triggerHandler('blur');
    this.setLastSavedState();
    this.hideDropdown();
  }

  cancelButtonClicked() {
    this.recoverLastSavedState();
    this.hideDropdown();
  }

  updateFromTime() {
    this.updateTime(this.dateRangeModel.from, this.fromTime);
  }

  updateToTime() {
    this.updateTime(this.dateRangeModel.to, this.toTime);
  }

  updateTime(dateModel, timeModel) {
    dateModel.setHours(timeModel.hours);
    dateModel.setMinutes(timeModel.minutes);
    this.setDateRangeViewValue();
    this.ngModel.$setTouched();
  }

  setFromRangeTimes() {
    [this.fromMinTime, this.fromMaxTime] = this.setRangeTimes(
      this.dateRangeModel.from, this.minFromDate, this.maxFromDate
    );
  }

  setToRangeTimes() {
    [this.toMinTime, this.toMaxTime] = this.setRangeTimes(
      this.dateRangeModel.to, this.minToDate, this.maxToDate
    );
  }

  setRangeTimes(dateModel, minDate, maxDate) {
    let minTime, maxTime;

    if (minDate && this.moment(dateModel).isSame(minDate, 'day')) {
      minTime = {
        hours: minDate.getHours(),
        minutes: minDate.getMinutes()
      };
    } else {
      minTime = undefined;
    }

    if (maxDate && this.moment(dateModel).isSame(maxDate, 'day')) {
      maxTime = {
        hours: maxDate.getHours(),
        minutes: maxDate.getMinutes()
      };
    } else {
      maxTime = undefined;
    }

    return [minTime, maxTime];
  }

  setFromTime(dateModel) {
    if (dateModel && dateModel.from) {
      this.fromTime = {
        hours: dateModel.from.getHours(),
        minutes: dateModel.from.getMinutes()
      };
    } else {
      this.fromTime = undefined;
    }
  }

  setToTime(dateModel) {
    if (dateModel && dateModel.to) {
      this.toTime = {
        hours: dateModel.to.getHours(),
        minutes: dateModel.to.getMinutes()
      };
    } else {
      this.toTime = undefined;
    }
  }

  setTime(dateModel) {
    this.setFromTime(dateModel);
    this.setToTime(dateModel);
  }

}

const daterangeComponent = {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    fromPlaceholder: '@',
    toPlaceholder: '@',
    applyButtonText: '@',
    cancelButtonText: '@',
    mode: '@',
    format: '@',
    min: '<',
    max: '<',
    hourStep: '<',
    minuteStep: '<',
    isDisabled: '<',
    isReadonly: '<',
    rangeFilters: '<',
    onFilterChange: '&',
    dateDisabled: '<',
    fromOptions: '<',
    toOptions: '<'
  },
  controller: DaterangeController,
  template($element, $attrs) {
    let masterTemplate = '';
    let tpl = template;

    if (angular.isUndefined($attrs.noMeridian)) {
      tpl = template.replace(/no-meridian/g, '');
    }
    masterTemplate = defaultTemplate.replace(`<div class="date-range"></div>`, tpl);

    return angular.element(masterTemplate)[0].outerHTML;
  }
};

daterangeComponent.template.$inject = ['$element', '$attrs'];
export default daterangeComponent;
